import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import * as React from 'react';
import { StyledItemLoading } from './styled';

export interface ItemLoadingProps {
  icon?: boolean;
}

const ItemLoading: React.FC<ItemLoadingProps> = ({ icon }) => (
  <StyledItemLoading>
    {icon && (
      <Box p={1}>
        <Skeleton variant="rectangular" width="24px" height="24px" />
      </Box>
    )}
    <Skeleton width="100%" />
  </StyledItemLoading>
);

ItemLoading.displayName = 'ItemLoading';

export default ItemLoading;
